var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownArrowRight = function SvgDownArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.994,
    height: 21.504,
    viewBox: "0 0 25.994 21.504",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3978",
    "data-name": "Caminho 3978",
    d: "M338.791,328.2a.8.8,0,0,0-.569.237.8.8,0,0,0,0,1.136h0l6.806,6.808a.806.806,0,0,0,1.136,0l6.81-6.811a.83.83,0,0,0,.253-.606.794.794,0,0,0-.245-.561.69.69,0,0,0-.562-.226.8.8,0,0,0-.573.245l-5.441,5.451V320.932a5.838,5.838,0,0,0-5.825-5.825H328.041a.8.8,0,0,0,0,1.606h12.545a4.225,4.225,0,0,1,4.215,4.214v12.938l-5.444-5.435A.8.8,0,0,0,338.791,328.2Z",
    transform: "translate(-327.238 -315.107)",
    fill: "#898989"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down-arrow-right.f42cc63c.svg";
export { ForwardRef as ReactComponent };